(function () {
  var root = document.querySelector('[data-bundle-builder]');
  if (!root) return;

  var radios = root.querySelectorAll('input[type="radio"]');
  var savingsEl = root.querySelector('[data-bundle-savings-text]');
  var savingsAmountEl = root.querySelector('[data-bundle-savings-amount]');
  var atcButton = root.querySelector('[data-bundle-add-to-cart]');
  var atcLabel = root.querySelector('[data-bundle-atc-label]');
  var currency = root.getAttribute('data-currency') || 'USD';

  var tierData = {
    '1': { price: parseFloat(root.getAttribute('data-tier1-price')), compare: parseFloat(root.getAttribute('data-tier1-compare')) },
    '2': { price: parseFloat(root.getAttribute('data-tier2-price')), compare: parseFloat(root.getAttribute('data-tier2-compare')) },
    '3': { price: parseFloat(root.getAttribute('data-tier3-price')), compare: parseFloat(root.getAttribute('data-tier3-compare')) }
  };

  function currentTier() {
    var checked = root.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '1';
  }

  function updateSavings() {
    var tier = currentTier();
    var d = tierData[tier];
    var saved = Math.max(0, d.compare - d.price);
    var formatted = saved.toLocaleString(undefined, { style: 'currency', currency: currency }).replace(/\.00$/, '');
    savingsAmountEl.textContent = savingsEl.getAttribute('data-bundle-savings-text').replace('[amount]', formatted);
  }

  function updateGifts() {
    var tier = parseInt(currentTier(), 10);
    root.querySelectorAll('[data-bundle-gift]').forEach(function (giftEl) {
      var unlockTier = parseInt(giftEl.getAttribute('data-unlock-tier'), 10);
      giftEl.classList.toggle('is-unlocked', tier >= unlockTier);
    });
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      updateSavings();
      updateGifts();
    });
  });

  updateSavings();
  updateGifts();

  root.querySelectorAll('[data-bundle-select-wrap]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-bundle-select-trigger]');
    var list = wrap.querySelector('[data-bundle-select-list]');
    var nativeSelect = wrap.querySelector('select[data-bundle-pick]');
    var thumb = wrap.querySelector('[data-bundle-select-thumb]');
    var label = wrap.querySelector('[data-bundle-select-label]');

    function closeList() {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function openList() {
      document.querySelectorAll('[data-bundle-select-list]').forEach(function (otherList) {
        if (otherList !== list) otherList.hidden = true;
      });
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (list.hidden) { openList(); } else { closeList(); }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeList();
    });

    list.querySelectorAll('[data-bundle-select-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.getAttribute('data-value');
        var img = option.querySelector('img');
        var text = option.querySelector('span');

        nativeSelect.value = value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        if (thumb && img) thumb.src = img.src;
        if (label && text) label.textContent = text.textContent;

        list.querySelectorAll('[data-bundle-select-option]').forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        option.classList.add('is-selected');
        option.setAttribute('aria-selected', 'true');

        closeList();
        trigger.focus();
      });
    });
  });

  document.addEventListener('click', function (e) {
    root.querySelectorAll('[data-bundle-select-wrap]').forEach(function (wrap) {
      if (!wrap.contains(e.target)) {
        var list = wrap.querySelector('[data-bundle-select-list]');
        var trigger = wrap.querySelector('[data-bundle-select-trigger]');
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  atcButton.addEventListener('click', function () {
    var tier = currentTier();
    var items = [{ id: parseInt(root.getAttribute('data-product-variant-id'), 10), quantity: 1 }];

    if (tier === '2' || tier === '3') {
      var tierEl = root.querySelector('.bundle-tier--' + tier);
      tierEl.querySelectorAll('select[data-bundle-pick]').forEach(function (select) {
        if (select.value) items.push({ id: parseInt(select.value, 10), quantity: 1 });
      });
      var gift1Id = root.getAttribute('data-gift-1-variant-id');
      if (gift1Id) items.push({ id: parseInt(gift1Id, 10), quantity: 1 });
    }
    if (tier === '3') {
      var gift2Id = root.getAttribute('data-gift-2-variant-id');
      if (gift2Id) items.push({ id: parseInt(gift2Id, 10), quantity: 1 });
    }

    atcButton.setAttribute('disabled', 'disabled');
    atcLabel.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.message || 'Could not add to cart'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        atcButton.removeAttribute('disabled');
        atcLabel.textContent = 'Add to cart';
        alert(err.message || 'Something went wrong adding this bundle to your cart.');
      });
  });
})();
